module.exports = __webpack_public_path__ + "img/check.b02ac2f7.svg";